import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'How is this different from NoFap?',
  a: "NoFap relies heavily on counting days, willpower, and restriction, which often leads to a 'binge and purge' cycle. UNHOOKED focuses on dismantling the desire itself through neuroscience. When you understand the mechanism, the days become irrelevant because you simply lose interest in the behavior."
}, {
  q: 'Do I need to quit immediately?',
  a: 'No. In fact, we encourage you to simply read the book first without forcing any behavioral changes. As you begin to understand the mechanisms of your dopamine system, the compulsion will naturally begin to fade without forced restriction.'
}, {
  q: 'Is this based on neuroscience?',
  a: 'Yes. The framework is built on modern understandings of dopamine regulation, neuroplasticity, and habit formation. However, it is translated into calm, accessible, and actionable concepts rather than dense medical jargon.'
}, {
  q: 'How quickly will I notice changes?',
  a: 'Many readers report a profound shift in perspective within the first few chapters as the shame lifts. Biological changes—like restored focus, deeper sleep, and returning baseline dopamine levels—typically become noticeable within the first 7 to 14 days.'
}, {
  q: 'Is this private?',
  a: 'Completely. Your purchase appears discreetly on your statement, and the digital files are delivered instantly to your email. There are no physical mailings or community forums you are forced to join.'
}, {
  q: 'What exactly do I receive?',
  a: 'You receive instant access to the UNHOOKED digital guide in PDF, EPUB, and MOBI formats, perfectly formatted for reading on your phone, tablet, Kindle, or computer.'
}, {
  q: 'Is this a subscription?',
  a: 'No. This is a one-time purchase for lifetime access to the guide and any future updates.'
}, {
  q: "What if this doesn't work for me?",
  a: "We offer a calm, no-questions-asked 30-day guarantee. If the framework doesn't resonate with you or help shift your perspective, simply reply to your receipt email and we will refund your purchase in full."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 sm:py-16 bg-charcoal relative" data-id="element-31">
      <div className="max-w-3xl mx-auto px-6" data-id="element-32">
        <div className="text-center mb-10" data-id="element-33">
          <div className="text-gold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-34">
            Clarity
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl text-ivory" data-id="element-35">
            Questions
          </h2>
        </div>

        <div className="space-y-1" data-id="element-36">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border-b border-gold/10" data-id="element-37">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-38">
                  <span className="text-lg sm:text-xl text-ivory/90 font-medium group-hover:text-gold transition-colors pr-8" data-id="element-39">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-gold/60 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-40" />
                </button>
                <AnimatePresence data-id="element-41">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-42">
                      <p className="pb-6 text-ivory/70 text-base sm:text-lg font-light leading-relaxed" data-id="element-43">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}